export function handleLightsPacket(id,payload,lights,events){
  if(id===0x183 && payload.length===8){
    const v=new DataView(payload.buffer,payload.byteOffset,payload.byteLength);
    lights.timer=Math.round(v.getUint32(0,true)/1000);
    lights.ledBar=Math.round(v.getUint32(4,true)/1000);
  }else if(id===0x283 && payload.length===1){lights.button=payload[0]?'On':'Off';}
  else return false;
  events.emit('lights',lights);return true;
}
